export const themes = {
  dark: {
    backgroundColor: "hsl(213, 5%, 24%)",
    selectedBorderColor: "hsl(213, 5%, 80%)",
    unselectedBorderColor: "hsl(213, 5%, 28%)",
    textColor: "hsl(213, 5%, 80%)",
  },
  light: {
    backgroundColor: "hsl(213, 5%, 80%)",
    textColor: "hsl(213, 5%, 24%)",
    unselectedBorderColor: "hsl(213, 5%, 70%)",
    selectedBorderColor: "hsl(213, 5%, 30%)",
  },
};
